import { render, staticRenderFns } from "./dp-box.vue?vue&type=template&id=02e163f4"
import script from "./dp-box.vue?vue&type=script&lang=js"
export * from "./dp-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports